import { render, staticRenderFns } from "./CandidateChip.vue?vue&type=template&id=1c311174"
import script from "./CandidateChip.vue?vue&type=script&lang=js"
export * from "./CandidateChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports